// extracted by mini-css-extract-plugin
export default {"wrapper":"_3BKCf4bRk62P0TAseAD2kh","navStroke":"Q2NSUyyJrAss4Qtswn3Wr","navStroke2":"_2TqGEbw0HRRF-jHSN4GgMe"};